function objectToGetParamsWithUrl(params: Record<string, any>): string {
  return Object.keys(params)
    .map((key) => {
      if (Array.isArray(params[key])) {
        return params[key]
          .map(
            (val: any) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(
                val?.toString(),
              )}`,
          )
          .join('&');
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
    })
    .join('&');
}

export default objectToGetParamsWithUrl;
